import { useState } from "react";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from "@/components/ui/collapsible";
import { ChevronDown, ChevronUp } from "lucide-react";
import { useTermsOfUse } from "@/hooks/useTermsOfUse";
import { Skeleton } from "@/components/ui/skeleton";

const TermosDeUso = () => {
  const { data: termsData, isLoading } = useTermsOfUse();
  const [isCurrentTermOpen, setIsCurrentTermOpen] = useState(true);

  const formatDate = (dateString: string) => {
    return new Date(dateString).toLocaleString("pt-BR", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  if (isLoading) {
    return (
      <div className="container mx-auto p-6 space-y-6">
        <div className="flex justify-between items-center">
          <div>
            <Skeleton className="h-8 w-64 mb-2" />
            <Skeleton className="h-4 w-96" />
          </div>
        </div>
        <Skeleton className="h-96 w-full" />
      </div>
    );
  }

  const currentTermo = termsData?.activeTerm;

  return (
    <div className="container mx-auto p-6 space-y-6">
      <div className="flex justify-between items-center">
        <div>
          <h1 className="text-3xl font-bold">Termos de Uso</h1>
          <p className="text-muted-foreground mt-1">
            Versão atual dos termos de uso do Portal MUSA
          </p>
        </div>
      </div>

      {/* Termo Atual */}
      {currentTermo ? (
        <Card>
          <Collapsible open={isCurrentTermOpen} onOpenChange={setIsCurrentTermOpen}>
            <CardContent className="pt-6">
              <div className="flex justify-between items-start mb-4">
                <div>
                  <h2 className="text-xl font-semibold">Versão Atual</h2>
                  <p className="text-sm text-muted-foreground">
                    Publicado em {formatDate(currentTermo.created_at || '')}
                  </p>
                </div>
                <CollapsibleTrigger asChild>
                  <Button variant="ghost" size="sm">
                    {isCurrentTermOpen ? (
                      <ChevronUp className="h-4 w-4" />
                    ) : (
                      <ChevronDown className="h-4 w-4" />
                    )}
                  </Button>
                </CollapsibleTrigger>
              </div>
              <CollapsibleContent>
                <div
                  className="prose prose-sm max-w-none mt-4"
                  dangerouslySetInnerHTML={{ __html: currentTermo.content }}
                />
              </CollapsibleContent>
            </CardContent>
          </Collapsible>
        </Card>
      ) : (
        <Card>
          <CardContent className="pt-6">
            <p className="text-center text-muted-foreground py-8">
              Nenhum termo de uso foi publicado ainda.
            </p>
          </CardContent>
        </Card>
      )}
    </div>
  );
};

export default TermosDeUso;
